import React from "react";
import {
  Grid,
  GridColumn,
  GridRow,
  Header,
  Icon,
  IconGroup,
} from "semantic-ui-react";
import HomepageSignpostButton from "./homepage-signpost-button";

const HomepageSignpost = () => {
  return (
    <Grid stackable>
      <GridRow stretched columns={1}>
        <GridColumn>
          <Header as="h2" style={{ color: "#ff9900" }}>
            Welcome to Digital Asset Register!
          </Header>
          <p>
            The Digital Asset Register (DAR) is eLTERs metadata catalogue and
            provides two main functions. You can search and explore published
            and publicly available data and eLTER data products from eLTER Sites
            and eLTER Platforms up to European scales, or you can contribute new
            datasets resulting from research conducted at eLTER Sites and eLTER
            Platforms or otherwise relevant to eLTER.
          </p>
        </GridColumn>
      </GridRow>
      <GridRow stretched columns={2}>
        <GridColumn>
          <HomepageSignpostButton
            backgroundColor="#96CE58"
            icon={<Icon size="huge" name="search" />}
            title="Explore available assets"
            href="/search"
            description="Discover and access a growing collection of environmental assets contributed by the eLTER research community."
          />
        </GridColumn>
        <GridColumn>
          <HomepageSignpostButton
            backgroundColor="#BADFFD"
            icon={
              <IconGroup size="huge">
                <Icon name="file alternate outline" />
                <Icon corner="bottom right" name="add" />
              </IconGroup>
            }
            title="Contribute with a new asset"
            href="/_new"
            description="Share your data with the eLTER RI community. This feature is available to registered and logged-in users only."
          />
        </GridColumn>
      </GridRow>
    </Grid>
  );
};

export default HomepageSignpost;
